import { useEffect, useState } from "react";
import {
    markTourAsCompleted,
    resetTour as resetTourUtil,
    shouldShowTour,
} from "../components/GuidedTourSteps";

export function useGuidedTour(tourId: string) {
    const [isTourOpen, setIsTourOpen] = useState(false);
    useEffect(() => {
        if (shouldShowTour(tourId)) {
            // Small delay to ensure the UI is fully rendered
            const timer = setTimeout(() => {
                setIsTourOpen(true);
            }, 1500);

            return () => clearTimeout(timer);
        }
    }, [tourId]);

    const completeTour = () => {
        // Mark the tour as completed
        markTourAsCompleted(tourId);
        setIsTourOpen(false);
    };

    const resetTour = () => {
        resetTourUtil(tourId);
        setTimeout(() => {
            setIsTourOpen(true);
        }, 300);
    };

    return {
        isTourOpen,
        completeTour,
        resetTour,
    };
}
